// Замеры маршрутизации: каждый вызов route() кладёт запись в window.__routingStats
// (до 500), чтобы сравнить серверный и клиентский расчёт на реальном устройстве.
export interface RoutingStat {
  mode: "server" | "client";
  ms: number;
  status: string;
  fetchMs?: number;
  decodeMs?: number;
  indexMs?: number;
  routeMs?: number;
  fetchedChunk?: boolean;
  tiles?: number;
  storeTiles?: number;
  bytes?: number;
}

const MAX = 500;

export function recordRoutingStat(stat: RoutingStat): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as { __routingStats?: RoutingStat[] };
  const list = (w.__routingStats ??= []);
  list.push(stat);
  if (list.length > MAX) list.shift();
}

const pct = (sorted: number[], p: number) => (sorted.length ? sorted[Math.min(sorted.length - 1, Math.ceil(p * sorted.length) - 1)] : 0);

export function summarizeRoutingStats(): Record<"server" | "client", { n: number; medianMs: number; p95Ms: number }> {
  const list = (typeof window === "undefined" ? [] : ((window as unknown as { __routingStats?: RoutingStat[] }).__routingStats ?? []));
  const out = { server: { n: 0, medianMs: 0, p95Ms: 0 }, client: { n: 0, medianMs: 0, p95Ms: 0 } };
  for (const mode of ["server", "client"] as const) {
    const ms = list.filter((s) => s.mode === mode).map((s) => s.ms).sort((a, b) => a - b);
    out[mode] = { n: ms.length, medianMs: pct(ms, 0.5), p95Ms: pct(ms, 0.95) };
  }
  return out;
}
